import {Button} from '@material-ui/core';
import React from 'react';

const PasswordRecoveryEmailSent = () => {

  return (
    <div className="password-recovery">
      <div className="password-recovery__form">
        <h1>Email Sent</h1>
        <p className="password-recovery__description">
          If there is an email associated with the username provided, a password recovery link has been sent. Please
          check your email to complete the recovery process.
        </p>
        <Button
          className="btn"
          id="password-recovery-return-to-login-button"
          fullWidth
          onClick={() => (window.location.hash = '/login')}
          variant="contained"
          color="primary"
        >
          Return to Login
        </Button>
      </div>
    </div>
  );
};

export default PasswordRecoveryEmailSent;
